<template>
  <div>
    <div>
      <img
      class="logo3 margin-top-05x"
      style="margin-left:40%"
      :src="uploadpath + 'resource/' + Res.shouye_logo"
      alt=""
    />
    </div>
    <div
      class="
        flex-row flex-center
        bg-g13
        justify-between
        margin-top-1x margin-left-3x
        height-60
        padding-left-3x
        border-10x
        margin-right-3x
      "
      @click="routeto('search')"
    >
      <div class="flex-row flex-center">
        <img
          class="icon-13x"
          :src="uploadpath + 'resource/' + Res.search"
          alt=""
        />
        <input class="border-none bg-g13 f-24" placeholder="输入您想要的内容" />
      </div>
      <button class="border-10x f-w f-24 border-none bg-g9 width-15x height-60">
        搜索
      </button>
    </div>

    <div class="h-85 flex-row flex-center bd-bottom scrollX">
      <div
        class="text-center margin-left-3x sinke"
        v-for="(item, i) in type"
        v-bind:key="i"
        @click="dianji(item.id, 'A')"
      >
        <div class="margin-bottom margin-top margin-left margin-right " :class="biaoti == item.id?'f-s2':'f-b2'">{{ item.name }}</div>
        <div class="h-6"><div class="guangbiao" v-if="biaoti == item.id"></div></div>
      </div>
    </div>

    <div class="flex-row flex-center h-80">
      <div class="justify-center" style="width: 50%">
        <div
          class="flex-row flex-center width border-25x justify-center h-51"
          :class="seqtype == 'A' ? 'btn-r' : 'btn-g'"
        >
          <img class="icon-13x" :src="seqimage" alt="" />
          <div
            :class="seqtype == 'A' ? 'f-d1' : 'f-s2'"
            @click="dianji(seqway, 'A')"
          >
            热度排序
          </div>
        </div>
      </div>
      <div class="justify-center" style="width: 50%">
        <div
          class="flex-row flex-center width border-25x justify-center h-51"
          :class="seqtype == 'A' ? 'btn-g' : 'btn-r'"
        >
          <img class="icon-13x" :src="seqimage1" alt="" />
          <div
            :class="seqtype == 'A' ? 'f-s2' : 'f-d1'"
            @click="dianji(seqway, 'B')"
          >
            优度排序
          </div>
        </div>
      </div>
    </div>
    <div class="bg-g scrollY h-68">
      <div
        class="margin-left-3x width-330 bg-w margin-top sinke tp"
        v-for="(item, i) in shoplist"
        v-bind:key="i"
        style="display: inline-block"
        @click="detail(item.id)"
      >
        <div>
          <img
            class="icon-15x tp"
            :src="uploadpath + 'shop/' + item.image"
            alt=""
          />
        </div>
        <div class="h2 margin-top-3x margin-left margin-right chaochu margin-bottom">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="bg-g2 padding-top padding-bottom">
      <div
        class="
          text-center
          f-20 f-g3
          margin-top-3x
          flex-row flex-center
          justify-center
          margin-bottom
        "
      >
        <div class="f-s1 f-24" @click="routeto('about')">关于我们</div>
        <div class="margin-left margin-right f-s1 f-24">|</div>
        <div class="f-s1 f-24" @click="panduan()">意见反馈</div>
      </div>
      <div class="text-center f-20 f-g3 margin-bottom margin-top-1x">
        {{Inst.copyright}}
      </div>
      <div class="text-center f-20 margin-bottom margin-top-1x f-p2" style="text-decoration:underline;" @click="gongxin()">
        {{ Inst.filing }}
      </div>
    </div>
    <div>
      <img
        class="icon-11x under1"
        :src="uploadpath + 'resource/' + Res.wydp"
        alt=""
        @click="pandaun1()"
      />
      <img
        class="icon-11x under2"
        :src="uploadpath + 'resource/' + Res.wode"
        alt=""
        @click="pandaun()"
      />
    </div>
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import { Toast } from "vant";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      type: [],
      shoplist: [],
      image: "",
      biaoti: "",
      token: "",
      seqway: 0,
      seqtype: "A",
      seqimage: "",
      seqimage1: "",
      first:0
    };
  },

  created() {
    PageHelper.Init(this);
    HttpHelper.Post("shop/type", {}).then((ret) => {
      this.type = ret;
      // console.log(ret)
      this.dianji(ret[0].id, "A");
      this.seqway = ret[0].id;
    });
    this.token = window.localStorage.getItem("token");
    //首页不缓存
    this.$route.meta.keepAlive=true;
    console.log(this.token);
  },
  methods: {
    dianji(id, seqtype) {
      console.log(seqtype);
      this.seqway = id;
      this.seqtype = seqtype;
      HttpHelper.Post("shop/shoplist", { type: id, way: seqtype }).then(
        (ret) => {
          console.log(ret);
          this.shoplist = ret;
        }
      );
      this.biaoti = id;
      this.imglist(seqtype);
    },
    imglist(seqtype) {
      if (seqtype == "A") {
        this.seqimage = this.uploadpath + "resource/" + this.Res.xz_hot;
        this.seqimage1 = this.uploadpath + "resource/" + this.Res.good;
      } else {
        this.seqimage = this.uploadpath + "resource/" + this.Res.hot;
        this.seqimage1 = this.uploadpath + "resource/" + this.Res.xz_good;
      }
    },
    detail(id) {
      // this.$route.meta.keepAlive=true;
      this.routeto("/detail/" + id+"/"+1);
    },
    pandaun() {
      this.Token();
      this.$route.meta.keepAlive=false;
      if (this.token == "null" || this.token == "" || this.token == null) {
        Toast("请先登录！");
        this.routeto("/login");
      } else {
        this.routeto("/my");
      }
    },
    pandaun1() {
      this.Token();
      if (this.token == "null" || this.token == "" || this.token == null) {
        Toast("请先登录！");
        this.routeto("/login");
      } else {
        this.routeto("/type");
      }
    },
    panduan() {
      this.$route.meta.keepAlive=false;
      if (this.token == "null" || this.token == "" || this.token == null) {
        Toast("请先登录！");
        this.routeto("/login");
      } else {
        this.routeto("/suggest");
      }
    },
    Token(){
      //首页会缓存
      this.$route.meta.keepAlive=false;
      this.token = window.localStorage.getItem("token");
    },
    gongxin(){
      window.location.href = this.Inst.url
    }
  },
};
</script>
<style scoped>
  .logo3 {
  height: 52px;
  width: 133px;
}
.under1 {
  position: fixed;
  z-index: 10;
  bottom: 18%;
  right: 0;
}
.under2 {
  position: fixed;
  z-index: 10;
  bottom: 10%;
  right: 0;
}
.btn-r {
  background: rgba(246, 78, 84, 0.1);
}
.btn-g {
  background: #f6f6f6;
}
.scrollX {
  overflow-x: scroll;
}
.scrollY {
  overflow-y: scroll;
}
.sinke {
  flex-shrink: 0;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.h-6{
  height: 6px;
}
.tp{
  border-radius: 15px 15px 0 0;
}

</style>


// WEBPACK FOOTER //
// src/components/Home.vue